import React from "react";

function triggerExternalPop() {
  return (
    window.navigator.userAgent.match("Safari/[0-9]+") &&
    !window.navigator.userAgent.match("Chrom")
  );
}

export class RedirectToBack extends React.Component {
  getRedirectUrl() {
    if (this.props.redirectTo) {
      return this.props.redirectTo;
    }
  }

  onBackNav(cb) {
    window.history.pushState(null, null, window.location.href);

    window.addEventListener("popstate", e => {
      if (sessionStorage.getItem("skip")) {
        sessionStorage.removeItem("skip");
      } else {
        if (triggerExternalPop()) {
          sessionStorage.setItem("skip", 1);
        }
        cb();
      }
    });
  }

  componentDidMount() {
    console.log(this.props.redirectTo)
    if (this.getRedirectUrl()) {
      this.onBackNav(() => {
        const url = this.getRedirectUrl();
        window.location.href = url;
      });
    }
  }

  render() {
    return null;
  }
}

export default RedirectToBack;
